import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import playerPlaceholder from '@assets/images/placeholder/playerPagePlaceholder.svg'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const SquadsCard = ({ data }) => {
  function getRole(sPlayingRole) {
    switch (sPlayingRole) {
      case 'wk':
        return 'Wicket Keeper'
      case 'all':
        return 'All Rounder'
      case 'bat':
        return 'Batsman'
      case 'bowl':
        return 'Bowler'
      default:
        return 'Wicket Keeper Batsman'
    }
  }
  if (data?.eTagStatus === 'a') {
    return (
      <CustomLink href={'/' + data?.oSeo?.sSlug} prefetch={false}>
        <a className={`${styles.squadsCard} common-box d-flex align-items-center`}>
          <div className={`${styles.icon} overflow-hidden me-2`}>
            {(data?.oSeo?.eType === 'p' || !data?.oSeo?.eType) && (
              <MyImage
                src={data?.oImg?.sUrl ? getImgURL(data?.oImg?.sUrl) : playerPlaceholder}
                blurDataURL={playerPlaceholder}
                alt={data?.sFullName || 'Player Image'}
                placeholder="blur"
                layout="responsive"
                width="40"
                height="40"
                autoRadiusImage
                errorImage={playerPlaceholder}
              />
            )}
          </div>
          <div>
            <h3 className="small-head small-head font-semi mb-0">{data?.sFullName || data?.sTitle || data?.sFirstName}</h3>
            {data?.sSeason && <p className="small-text secondary-text mb-0 mt-1">{data?.sSeason}</p>}
            {(data?.oSeo?.eType === 'p' || !data?.oSeo?.eType) && (
              <p className="small-text secondary-text mb-0 mt-1">
                <span className="text-capitalize text-muted">{getRole(data?.sPlayingRole)}</span>
              </p>
            )}
          </div>
        </a>
      </CustomLink>
    )
  } else {
    return (
      <div className={`${styles.squadsCard} common-box d-flex align-items-center`}>
        <div className={`${styles.icon} overflow-hidden me-2`}>
          {(data?.oSeo?.eType === 'p' || !data?.oSeo?.eType) && (
            <MyImage
              src={getImgURL(data?.oImg?.sUrl) || playerPlaceholder}
              blurDataURL={playerPlaceholder}
              alt={data?.sFullName || 'Player Image'}
              placeholder="blur"
              layout="responsive"
              width="40"
              height="40"
              autoRadiusImage
            />
          )}
        </div>
        <div>
          <h3 className="small-head small-head font-semi mb-0">{data?.sFullName || data?.sTitle || data?.sFirstName}</h3>
          {data?.sSeason && <p className="small-text secondary-text mb-0 mt-1">{data?.sSeason}</p>}
          {(data?.oSeo?.eType === 'p' || !data?.oSeo?.eType) && (
            <p className="small-text secondary-text mb-0 mt-1">
              <span className="text-capitalize text-muted">{getRole(data?.sPlayingRole)}</span>
            </p>
          )}
        </div>
      </div>
    )
  }
}
SquadsCard.propTypes = {
  data: PropTypes.object
}

export default SquadsCard
